<template>
  <select :data-vv-as="field.description.replace(/\./g, '')"
          class="form-control"
          :id="field.name"
          :name="field.name"
          :value="value"
          v-validate="{required: required && !field.hide}"
          :disabled="locked"
          @change="$emit('input', $event.target.value)"
  >
    <option value="" selected>Select option...</option>
    <option v-for="option in field.values"
            :key="option.name"
            :value="option.label"
            v-if="!isValueHidden(option.label)">
      {{ option.label }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
    hiddenValues: {
      type: Array,
      default: false,
    }
  },

  emits: ['input'],

  setup(props) {
    // TODO: move to composable
    const isValueHidden = (value) => {
      if (props.hiddenValues) {
        return props.hiddenValues.some(h => {
          return h.field === props.field.name && value === h.value
        })
      }
      return false;
    }

    return {
      isValueHidden,
    }
  }
}
</script>

<style scoped lang="scss">
.mt-checkbox-list, .mt-radio-list {
  padding: 0;
  display: block;
}
</style>



// WEBPACK FOOTER //
// DropdownRender.vue?a23e5580